/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-21 11:44:29
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-05-12 11:32:35
 * @FilePath: /designcenter/src/api/modules/templateManange.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'

const request = getApiRequest()

// 创建项目或者编辑项目
export async function createProject(data: any) {
  return request.post<IRes<unknown>>('/design/project/edit', data)
}

export async function createNewDiag(data: any) {
  return request.post<IRes<unknown>>('/design/topology/createNewDiag', data)
}

export async function copyDiagram(data: any) {
  return request.post<IRes<unknown>>('/design/topology/copyDiagram', data)
}


// 选择模板
export async function getTemplatePopupList() {
  return request.get<IRes<unknown>>('/design/template/list')
}

// 创建项目或者编辑项目
export async function getProjectList(data: any) {
  return request.post<IRes<unknown>>('/design/project/page', data)
}

// 项目详情
export async function getProjectDetail(data: any) {
  return request.get<IRes<unknown>>('/design/project/detail', { params: data })
}

// 绑定模板
export async function bindTemplate(data: any) {
  return request.post<IRes<unknown>>('/design/topology/bind',  data)
}

// 删除项目
export async function deleteProjectList(data: any) {
  return request.post<IRes<unknown>>('/design/project/remove', data)
}

//分享项目
export async function shareProject(data: any) {
  return request.post<IRes<unknown>>('/design/email/share', data)
}

//分享项目
export async function uploadImage(data: FormData) {
  return request.post<IRes<unknown>>('/design/file-upload/add', data)
}

//获取国家列表
export async function getCountryList() {
  return request.get<IRes<unknown>>('/design/country/list')
}

//客户 pdf
export async function exportCustomerPdf(data: any) {
  return request.post<IRes<unknown>>('/design/export/customer/pdf', data, {
    responseType: 'blob',
  })
}

//技术 pdf
export async function exportTechnologyPdf(data: any) {
  return request.post<IRes<unknown>>('/design/export/technology/pdf', data, {
    responseType: 'blob',
  })
}

//初始化项目
export async function initProject() {
  return request.get<IRes<unknown>>('/design/project/entry')
}

//查询用户是否被引导
export async function getUserGuide() {
  return request.get<IRes<unknown>>('/design/project/guide')
}

//设置用户引导
export async function setUserGuide() {
  return request.post<IRes<unknown>>('/design/project/setGuide')
}
